import { render, staticRenderFns } from "./veJkyAdminEdit.vue?vue&type=template&id=7fec228a&scoped=true"
import script from "./veJkyAdminEdit.vue?vue&type=script&lang=js"
export * from "./veJkyAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fec228a",
  null
  
)

export default component.exports